export class  ProductoItemDesgloce {
    IdProductoItem :number;
    IdProductoCompuesto:number;
    DescripcionReceta:string;
    Unidades :number;
    }